import * as Yup from 'yup';
import { Switch } from '../../../../../../shared/types/modules/switch';

export const initialValues: Switch = {
    callId: '',
    channel: '',
    typification1: '',
    typification2: '',
    official: '',
    ext: '',
    observation: '',
    isTransferAssistance: false,
    document: '',
    vehiclePlate: '',
    policyNumber: '',
    branch: '',
};

export const validationSchema = (
    requireTypification2: boolean,
    isTracking: boolean
) => {
    const schema: any = {
        callId: Yup.string().max(
            100,
            'El call ID debe tener 100 caracteres alfanuméricos como máximo'
        ),
        channel: Yup.string().required('El canal es obligatorio'),
        typification1: Yup.string().required(
            'La tipificación 1 es obligatoria'
        ),
        observation: Yup.string().required('La observación es obligatoria'),
    };

    if (requireTypification2)
        schema.typification2 = Yup.string().required(
            'La tipificación 2 es obligatoria'
        );
    if (isTracking) {
        schema.document = Yup.string().required(
            'El número de documento es obligatorio'
        );
        schema.vehiclePlate = Yup.string().required(
            'La placa del vehículo es obligatoria'
        );
        schema.policyNumber = Yup.string().required(
            'El número de póliza es obligatorio'
        );
        schema.branch = Yup.string().required('La sucursal es obligatoria');
    }

    return Yup.object(schema);
};
